import { useRef, useCallback, MutableRefObject } from 'react';

type UseInfiniteScrollParams = {
  callback: () => void;
  isLoading: boolean;
  hasMore: boolean;
};

export const useInfiniteScroll = ({
  callback,
  isLoading,
  hasMore,
}: UseInfiniteScrollParams) => {
  const observer: MutableRefObject<IntersectionObserver | null> = useRef(null);

  const lastElementRef = useCallback(
    (node: HTMLElement | null) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          callback();
        }
      });

      if (node) observer.current.observe(node);
    },
    [callback, isLoading, hasMore]
  );

  return { lastElementRef };
};
